import {
  Component, Inject, Injector, forwardRef, ElementRef, OnInit,
  Optional,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OSharedModule } from '../../../shared';
import { OFormComponent } from '../../form/o-form.component';
import {
  ORealInputModule, ORealInputComponent,
  DEFAULT_INPUTS_O_REAL_INPUT, DEFAULT_OUTPUTS_O_REAL_INPUT
} from '../real-input/o-real-input.component';
import { InputConverter } from '../../../decorators';

export const DEFAULT_INPUTS_O_PERCENT_INPUT = [
  ...DEFAULT_INPUTS_O_REAL_INPUT
];

export const DEFAULT_OUTPUTS_O_PERCENT_INPUT = [
  ...DEFAULT_OUTPUTS_O_REAL_INPUT
];


export class OPercentInputComponent extends ORealInputComponent implements OnInit {

  public static DEFAULT_INPUTS_O_PERCENT_INPUT = DEFAULT_INPUTS_O_PERCENT_INPUT;
  public static DEFAULT_OUTPUTS_O_PERCENT_INPUT = DEFAULT_OUTPUTS_O_PERCENT_INPUT;

  @InputConverter()
  grouping: boolean = true;

  @InputConverter()
  decimalDigits: number = 2;

  constructor(
      form: OFormComponent,
    elRef: ElementRef,
    injector: Injector) {
    super(form, elRef, injector);
  }

  public ngOnInit() {
    if (typeof (this.min) === 'undefined') {
      this.min = 0;
    }
    if (typeof (this.max) === 'undefined') {
      this.max = 100;
    }
    super.ngOnInit();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-percent-input',
  template: `
    <div fxLayout="row"  fxLayoutAlign="space-between center" [formGroup]="getFormGroup()" [mdTooltip]="tooltip" [mdTooltipPosition]="tooltipPosition"
        [mdTooltipShowDelay]="tooltipShowDelay">
        <md-form-field #innerInputContainer fxFlexFill>
            <input mdInput type="number" [attr.id]="getAttribute()" fxFill [formControlName]="getAttribute()" [placeholder]="placeHolder"
                [ngModel]="getValue()" (ngModelChange)="innerOnChange($event)" (focus)="innerOnFocus($event)" (blur)="innerOnBlur($event)"
                [readonly]="isReadOnly" [min]="min" [max]="max" [step]="step">
            
                <span class="icon-btn" [class.mat-disabled]="isDisabled" mdSuffix>%</span>
            <md-error *ngIf="hasError('required')">{{ 'FORM_VALIDATION.REQUIRED' | oTranslate }}</md-error>
            <md-error *ngIf="hasError('min')">{{ 'FORM_VALIDATION.MIN_VALUE' | oTranslate }}: {{ getErrorValue('min', 'requiredMin') }}</md-error>
            <md-error *ngIf="hasError('max')">{{ 'FORM_VALIDATION.MAX_VALUE' | oTranslate }}: {{ getErrorValue('max', 'requiredMax') }}</md-error>
            <md-error *ngIf="hasError('pattern')">{{ 'FORM_VALIDATION.FORMAT' | oTranslate }}</md-error>
        </md-form-field>
    
    </div>
  `,
  styles: [`

  `],
  inputs: [
    ...DEFAULT_INPUTS_O_PERCENT_INPUT
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_PERCENT_INPUT
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
}


export class OPercentInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OPercentInputComponent],
  imports: [OSharedModule, CommonModule, ORealInputModule],
  exports: [OPercentInputComponent, ORealInputModule],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
